export default "__VITE_ASSET__CLHwuc4f__"